import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import { color, spacing } from "rizzo-next/sass/settings.json";
import Icon from "backpack-ui/dist/components/icon";
import colors from "backpack-ui/dist/styles/colors";

const styles = {
  container: {
    base: {
      backgroundColor: colors.bgSecondary,
      fontSize: "11px",
      height: "40px",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  },

  dateSection: {
    base: {
      display: "flex",
      alignItems: "center",
      lineHeight: 1,
    },
    copy: {
      fontWeight: 400,
      marginLeft: "14px",
      color: colors.textPrimary,
    },
  },

  buttons: {
    base: {
      lineHeight: 1,
      marginTop: "-1px",
      overflow: "hidden",
    },
  },

  button: {
    base: {
      display: "inline-block",
      position: "relative",
    },

    notFirstChild: {
      marginLeft: "1px", // to offset Divider
    },

    lastChild: {
      paddingRight: spacing.mobile,
    },
  },

  anchor: {
    base: {
      display: "block",
      overflow: "hidden",
      padding: `23px ${spacing.mobile} 20px`,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "100%",
    },
  },

  divider: {
    base: {
      backgroundColor: color.gray,
      display: "block",
      height: "10px",
      right: "-1px",
      position: "absolute",
      top: "24px",
      width: "1px",
    },
  },

  icon: {
    base: {
      marginRight: "9px",
      verticalAlign: "baseline",
      top: "-1px",
    },
  },
};

function MobileToolbar({ children, showDates, selectedDates, style }) {
  return (
    <div className="MobileToolbar" style={[styles.container.base, style]}>

      <div className="MobileToolbar-date-section" >
        {showDates &&
          <div style={styles.dateSection.base}>
            <Icon.Calendar width={13} />
            <p style={styles.dateSection.copy}>{selectedDates || "No Dates Selected"} </p>
          </div>
        }
      </div>

      <div className="MobileToolbar-buttons" style={styles.buttons.base}>
        {React.Children.map(children, (child, index) => (
          <div
            className="MobileToolbar-button"
            style={[
              styles.button.base,
              index !== 0 && styles.button.notFirstChild,
            ]}
            key={`MobileToolbar-part${index}`}
          >
            {child}
            {index !== 1 &&
              <span
                className="Divider"
                style={styles.divider.base}
                aria-hidden="true"
              />
            }
          </div>
        ))}
      </div>
    </div>
  );
}

MobileToolbar.propTypes = {
  /**
   * Contents of toolbar
   */
  children: PropTypes.node.isRequired,

  /**
   * Selected dates of POI booking
   */
  selectedDates: PropTypes.string,

  /**
  * Whether or not to show the dates, only should be on bookings
  */
  showDates: PropTypes.boolean,

  /**
   * Style object to add or override container styles
   */
  style: PropTypes.object,
};

MobileToolbar.defaultProps = {
  children: null,

  selectedDates: "No Dates Selected",

  style: {},
};

export default radium(MobileToolbar);



// WEBPACK FOOTER //
// ./assets/list/components/mobileToolbar/index.jsx